module.exports = __webpack_public_path__ + "static/media/_scotland.aff4aaa1.png";